import { Alert, Snackbar } from '@mui/material';
import { useCallback, useState } from 'react';

const useToast = ({ autoHideDuration = 5000 } = {}) => {
    const [toast, setToast] = useState(null);

    const closeToast = useCallback(() => {
        setToast(null);
    }, []);

    const showInfoToast = useCallback((message) => setToast({ message, type: 'info' }), []);
    const showSuccessToast = useCallback((message) => setToast({ message, type: 'success' }), []);
    const showErrorToast = useCallback((message) => setToast({ message, type: 'error' }), []);

    const renderToast = (position = { vertical: 'top', horizontal: 'center' }) => (
        <Snackbar
            open={Boolean(toast)}
            onClose={closeToast}
            anchorOrigin={position}
            autoHideDuration={autoHideDuration}
        >
            <Alert onClose={closeToast} severity={toast?.type}>
                {toast?.message}
            </Alert>
        </Snackbar>
    );

    return { renderToast, showInfoToast, showSuccessToast, showErrorToast };
};

export default useToast;
